module.exports = __webpack_public_path__ + "static/media/calendar.2198303e.svg";